module.exports = __webpack_public_path__ + "static/media/googlePin13.610fb709.svg";